import { createTheme } from "@mui/material/styles";

const themeMuiFont = createTheme({
  typography: {
    fontFamily: '"Raleway", "Josefin Sans", "Roboto", "Verdana", "Geneva", "Tahoma", sans-serif',
  },
});

export default themeMuiFont;